import React from "react";
import { Card } from "antd";

const Users = () => {
  return (
    <Card title="مدیریت کاربران" style={{ margin: 16 }}>
      <p>اینجا لیست کاربران یا فرم‌های مربوط به مدیریت کاربران نمایش داده خواهد شد.</p>
    </Card>
  );
};

export default Users;
